import type { PurchaseSuggestion } from '@/services/procurement'

export type SuggestionKpis = {
  open: number
  converted: number
  dismissed: number
  total: number
}

export function computeSuggestionKpis(
  suggestions: PurchaseSuggestion[],
): SuggestionKpis {
  let open = 0
  let converted = 0
  let dismissed = 0
  for (const s of suggestions) {
    if (s.status === 'OPEN') open += 1
    else if (s.status === 'CONVERTED') converted += 1
    else if (s.status === 'DISMISSED') dismissed += 1
  }
  return { open, converted, dismissed, total: suggestions.length }
}
